import { fetchData } from "@client";

export async function checkPrivilegesQuery(code) {
  return await fetchData(`/premium/user/${code}`);
}
